// extracted by mini-css-extract-plugin
module.exports = {"banner":"TestSiteBanner_banner__ool1K"};